import { useState } from "react";
import { api } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const MIN_YEAR = 2026;

export default function NewMonthDialog({ open, onClose, onCreated }) {
  const [year, setYear] = useState(MIN_YEAR);
  const [month, setMonth] = useState(8);
  const [loading, setLoading] = useState(false);

  const create = async () => {
    setLoading(true);
    try {
      const res = await api.post("/months", { year: Number(year), month: Number(month) });
      toast.success(`Mese ${res.data.key} creato (${res.data.days} giorni)`);
      onCreated(res.data.key);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore creazione mese");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-white rounded-sm" data-testid="new-month-dialog" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="text-lg font-bold tracking-tight">Crea nuovo mese</DialogTitle>
        </DialogHeader>
        <div className="flex gap-3">
          <div className="flex-1">
            <label className="text-xs font-semibold uppercase text-slate-600">Anno</label>
            <Input data-testid="new-month-year" type="number" value={year} min={MIN_YEAR}
              onChange={(e) => setYear(e.target.value)} className="rounded-sm mt-1" />
          </div>
          <div className="flex-1">
            <label className="text-xs font-semibold uppercase text-slate-600">Mese</label>
            <Input data-testid="new-month-month" type="number" value={month} min={1} max={12}
              onChange={(e) => setMonth(e.target.value)} className="rounded-sm mt-1" />
          </div>
        </div>
        <p className="text-xs text-slate-500">Nome file mese: {String(year % 100).padStart(2, "0")} {String(month).padStart(2, "0")}</p>
        <Button data-testid="create-month-submit" onClick={create} disabled={loading}
          className="rounded-sm bg-slate-900 hover:bg-slate-700 text-white">
          {loading ? "Creazione..." : "Crea mese"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
